import { ProfileStoreActionsClass } from './ProfileStoreActionsClass';

const ProfileStore: ProfileStoreActionsClass = new ProfileStoreActionsClass();

export { ProfileStore };
